function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M21,13v9.5a.5.5,0,0,1-.5.5h-6a.5.5,0,0,1-.5-.5V16H10v6.5a.5.5,0,0,1-.5.5h-6a.5.5,0,0,1-.5-.5v-10a.5.5,0,0,1,1,0V22H9V15.5a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5V22h5V13a.5.5,0,0,1,1,0Zm2.85-1.35L12.35.15a.48.48,0,0,0-.7,0L.15,11.65a.48.48,0,0,0,0,.7.48.48,0,0,0,.7,0L12,1.21,23.15,12.35a.48.48,0,0,0,.7,0A.48.48,0,0,0,23.85,11.65ZM16,2h3V5a.5.5,0,0,0,1,0V1.5a.5.5,0,0,0-.5-.5H16a.5.5,0,0,0,0,1Z"
})));

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 23",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.9e7ec97e.svg";
export { ForwardRef as ReactComponent };